/* global importName */
import { getDeepProperty } from '@/helpers/deepObject.js'
import store from '@/services/store'

const EpisodeList = () => importName('@/scenes/Episodes/scenes/EpisodeList/EpisodeList.vue', 'episodeList')

const redirectRoutes = [
  {
    path: 'episodes',
    name: 'episodes-old',
    component: EpisodeList,
    meta: {
      breadcrumbs: [
        { title: 'Episodes' }
      ]
    },
    beforeEnter: async (to, from, next) => {
      // activePodcast loading will already be handled by the time we get here.
      // If it doesn't exist we can safely redirect to Overview so that the system
      // can grab whatever podcast we have access to
      let activePodcast = store.getters.activePodcast
      const currentAccount = store.getters.currentAccount
      const activePodcastUserPermissions = store.getters.activePodcastUserPermissions
      let activePodcastId = getDeepProperty(activePodcast, 'id')
      let accountId = getDeepProperty(activePodcast, 'account.id')
      if (!accountId || !store.getters.accounts.find((a) => a.id === accountId)) accountId = store.getters.defaultAccount.id

      if (!activePodcastId) {
        next({name: 'all-shows', params: {accountId: currentAccount}})
        return
      }
      if (activePodcast.status === 'pending' || activePodcast.import || !getDeepProperty(activePodcastUserPermissions, 'can_view_episodes')) {
        next({name: 'show-overview', params: { accountId: accountId, podcastId: activePodcastId }})
        return
      }

      next({name: 'episodes', params: { accountId: accountId, podcastId: activePodcastId } })
    }
  }
]

export default redirectRoutes
